import { DateInput } from 'cpool-components/input/DateInput';
import type { Control, FieldValues, Path } from 'react-hook-form';

import { FormField } from './FormField';
import { formatFormLabel } from '../formatFormLabel';

type FormDateInputProps<TFieldValues extends FieldValues> = {
    control: Control<TFieldValues>;
    disabled?: boolean;
    id: Path<TFieldValues>;
    label: string;
    labelClassName?: string;
    onValueChange?: (value: Date | null) => void;
    required?: boolean;
};

export const FormDateInput = <TFieldValues extends FieldValues>({
    control,
    disabled,
    id,
    label,
    labelClassName = 'h-8 w-[175px] shrink-0 justify-start',
    onValueChange,
    required,
}: FormDateInputProps<TFieldValues>) => (
    <FormField<TFieldValues, Date | null> control={control} name={id}>
        {({ error, onChange, value }) => (
            <DateInput
                id={id}
                label={formatFormLabel(label, required)}
                value={value}
                onChange={(newValue: Date | null) => {
                    onChange(newValue);
                    onValueChange?.(newValue);
                }}
                showDropdowns
                disabled={disabled}
                labelClassName={labelClassName}
                error={error}
            />
        )}
    </FormField>
);
